/*eslint-disable*/
export default [
    {
        path: 'select-course',
        name: 'select-course',
        component: () => import(/* webpackPrefetch: true */'../../components/select-course/SelectCourse.vue'),
        meta: {
            title: 'router.router_dashboard'
        }
    },
];
